module.exports = __webpack_public_path__ + "img/icon-local.f2755637.png";